<template>
    <el-container style="width:100%;">
        <el-header>
            <el-form @submit.native.prevent :inline="true" :model="fromConsumer" ref="fromConsumer" class="demo-form-inline">
                <td-permission :oneOfPermissions="permissionsQuery">
                    <div slot="havePermission">
                        <el-form-item :label="$t('common.CONSUMER_NAME')" prop="sConsumerName">
                            <td-input v-model="fromConsumer.sConsumerName"></td-input>
                        </el-form-item>
                        <el-form-item class="paddingLeft10">
                            <td-button type="primary" :permissions="permissionsQuery" @getPermissionsStatus="getPermissionsStatus" :loading="loading" @click="btnQuery">{{
                                $t('common.QUERY')
                            }}</td-button>
                        </el-form-item>
                    </div>
                </td-permission>
                <el-form-item>
                    <td-button type="button" :permissions="permissionsAdd" @click="btnAdd">{{ $t('common.ADD') }}</td-button>
                </el-form-item>
            </el-form>
        </el-header>
        <el-main>
            <!-- 加载表格 -->
            <td-table
                :columns="columns"
                :dataSource="tableData"
                :pageSize="pageSize"
                :currentPage="currentPage"
                :total="total"
                :hasLoading="tableLoading"
                :permissions="permissionsQuery"
                @handleSizeChange="handleSizeChange"
                @currentChange="currentChange"
                :hasMutiSelect="false"
            ></td-table>
            <!-- 加载dialog -->
            <dialog-ConsumerInfo
                v-if="dialogVisible"
                :isAddData="isAddData"
                :dialogVisible="dialogVisible"
                :listConsumerInfo="listConsumerInfo"
                :editItem="editItem"
                :title="title"
                ref="addOrModifyInfo"
                @dialogConsumerClose="dialogConsumerClose"
                @submit="submit"
            ></dialog-ConsumerInfo>
        </el-main>
    </el-container>
</template>

<script>
import thirdPartyApi from './assets/api.js';
import dialogConsumerInfo from './components/dialogConsumerInfo.vue';
export default {
    // 初始化渲染
    components: {
        'dialog-ConsumerInfo': dialogConsumerInfo
    },
    // 在页面渲染完成之后进行初始化工作
    mounted() {
        // this.queryInfoList(); // 进行页面初始化数据的加载
    },
    // 定义数据
    data() {
        return {
            permissionsQuery: ['thirdparty:view'],
            permissionsAdd: ['thirdparty:add'],
            fromConsumer: { sConsumerName: '' },
            editItem: '',
            queryShow: false,
            dialogVisible: false,
            listConsumerInfo: [], // 消费者下拉框数据
            tableData: [],
            isAddData: true, // 是否为添加数据
            pageSize: 10, // 每页条数
            currentPage: 1, // 当前页
            total: 0, // 总条数
            loading: false,
            tableLoading: false,
            columns: [
                {
                    prop: 'sResourceName',
                    label: 'common.CONSUMER'
                },
                {
                    prop: 'iType',
                    label: 'common.REQUEST_MODE',
                    align: 'center',
                    render: (createElement, params) => {
                        return createElement('label', this.transferType(params.row));
                    }
                },
                {
                    prop: 'sURL',
                    label: 'common.REQUEST_URL',
                    showOverflowTooltip: true
                },
                {
                    prop: '',
                    label: 'common.OPERATE',
                    align: 'center',
                    tableWidth: '90',
                    render: (createElement, params) => {
                        return createElement('div', [
                            createElement(
                                'td-button',
                                {
                                    props: { type: 'text', size: 'small', permissions: ['thirdparty:edit'] },
                                    on: {
                                        click: () => {
                                            this.btnExit(params.row);
                                        }
                                    }
                                },
                                this.$t('common.EDIT')
                            ),
                            createElement(
                                'td-button',
                                {
                                    props: { type: 'text', size: 'small', permissions: ['thirdparty:del'] },
                                    on: {
                                        click: () => {
                                            this.btnDelete(params.row.sId);
                                        }
                                    }
                                },
                                this.$t('common.DELETE')
                            )
                        ]);
                    }
                }
            ]
        };
    },
    // 方法的实现
    methods: {
        //页面权限设置
        getPermissionsStatus(permissions) {
            if (permissions) {
                this.btnQuery(); // 进行页面初始化数据的加载
            }
        },
        // 方式类型转换
        transferType(row) {
            switch (row.iType) {
                case 1:
                    return this.$t('common.WEB_SERVICE');
                    // eslint-disable-next-line no-unreachable
                    break;
                default:
                    return this.$t('common.WEB_SERVICE');
            }
        },

        // 获取每页条数
        handleSizeChange(pageSize) {
            this.pageSize = pageSize;
            this.submit();
        },
        // 获取当前页
        currentChange(currentPage) {
            this.currentPage = currentPage;
            this.submit();
        },
        queryInfoList() {
            let param = {
                resourceName: this.fromConsumer.sConsumerName,
                pageNum: this.currentPage,
                pageSize: this.pageSize,
                isPage: true
            };
            thirdPartyApi.listThirdPartyInfo(JSON.stringify(param), response => {
                if (response.status !== window.pgCommon.login.RESPONSE_STATUS) {
                    this.$log.error('thirdPartyManagement/listThirdPartyInfo', response);
                    this.loading = false;
                    return;
                }
                if (response.data.statusCode !== window.pgCommon.requestCode.SUCCESS_INFO_CODE) {
                    this.$message({ showClose: true, message: response.data.statusMessage, type: 'error' });
                    this.$log.error('thirdPartyManagement/listThirdPartyInfo', response.data.statusMessage);
                    this.loading = false;
                    return;
                }
                this.tableData = response.data.content.resultlist;
                this.total = response.data.content.total;
                this.loading = false;
            });
        },
        // 查询数据
        btnQuery() {
            this.loading = true;
            this.currentPage = 1;
            this.queryInfoList();
        },

        // 添加
        btnAdd() {
            this.listConsumerInfo = [];
            thirdPartyApi.queryConsumerInfo(null, response => {
                if (response.status !== window.pgCommon.login.RESPONSE_STATUS) {
                    this.$log.error('thirdPartyManagement/queryConsumerInfo', response);
                    return;
                }
                if (response.data.statusCode !== window.pgCommon.requestCode.SUCCESS_INFO_CODE) {
                    this.$message({ showClose: true, message: response.data.statusMessage, type: 'error' });
                    this.$log.error('thirdPartyManagement/queryConsumerInfo', response.data.message);
                    return;
                }
                let consumers = response.data.content;
                for (let i = 0; i < consumers.length; i++) {
                    let consumer = {};
                    consumer.value = consumers[i].sSrcId;
                    consumer.label = consumers[i].sName;
                    this.listConsumerInfo.push(consumer);
                }
                this.title = this.$t('common.ADD'); // 标题
                this.isAddData = true;
                this.dialogVisible = true;
            });
        },
        // 编辑
        btnExit(row) {
            this.listConsumerInfo = [
                {
                    value: row.sSrcId,
                    label: row.sResourceName
                }
            ];
            thirdPartyApi.queryConsumerInfo(null, response => {
                if (response.status !== window.pgCommon.login.RESPONSE_STATUS) {
                    this.$log.error('thirdPartyManagement/queryConsumerInfo', response);
                    return;
                }
                if (response.data.statusCode !== window.pgCommon.requestCode.SUCCESS_INFO_CODE) {
                    this.$message({ showClose: true, message: response.data.statusMessage, type: 'error' });
                    this.$log.error('thirdPartyManagement/queryConsumerInfo', response.data.message);
                    return;
                }
                let consumers = response.data.content;
                for (let i = 0; i < consumers.length; i++) {
                    let consumer = {};
                    consumer.value = consumers[i].sSrcId;
                    consumer.label = consumers[i].sName;
                    this.listConsumerInfo.push(consumer);
                }
                this.editItem = row;
                this.title = this.$t('common.EDIT');
                this.isAddData = false;
                this.dialogVisible = true;
            });
        },
        // 删除接口
        btnDelete(sId) {
            this.$confirm(this.$t('common.DELETE_INFO_TIPS'), this.$t('common.TIPS'), {
                confirmButtonText: this.$t('common.SURE'),
                cancelButtonText: this.$t('common.CANCEL'),
                type: 'warning'
            })
                .then(() => {
                    this.tableLoading = true;
                    let param = { sId: sId };
                    thirdPartyApi.deleteThirdPartyInfo(param, response => {
                        this.tableLoading = false;
                        if (response.data.statusCode !== window.pgCommon.requestCode.SUCCESS_INFO_CODE) {
                            this.$message({ showClose: true, message: response.data.statusMessage, type: 'error' });
                            this.$log.error('resourceManager/deleteThirdPartyInfo', response.data.statusMessage);
                            return;
                        }
                        this.$message({ type: 'success', showClose: true, message: this.$t('pgCommon.DELETE_SUCCESS') });
                        this.submit();
                    });
                })
                .catch(() => {});
        },
        // 组件关闭需要调用的方法
        submit() {
            this.queryInfoList();
        },
        // 关闭消费者管理添加页面
        dialogConsumerClose() {
            this.dialogVisible = false;
        }
    }
};
</script>
<style>
.btnStyle {
    text-align: center;
}
.el-dialog__header {
    background-color: #266eb1;
}
.el-dialog__headerbtn .el-dialog__close {
    color: #000 !important;
}
</style>
